let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("asR20")).then(() => parcelRequire('3Q7BL'));